<template>
  <div class="content-tab systime">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="forminput">
          <div class="table-row">
            <div class="title">{{$t('systemTime.currentDandT')}}</div>
            <span class="display-date value">{{displayTime}}</span>
          </div>
          <div class="table-row">
            <div class="title time-zone-title">{{$t('systemTime.timeZone')}}</div>
            <div class="time-zone">
              <div class="select-wrapper">
                <q-select class="q-select timezone-type" :value="timezonetype" :options-array="timezoneOptions" @change="onTimetypeChange"></q-select>
              </div>
              <div class="select-wrapper" v-if="timezonetype === 'time'">
                <span>{{$t('systemTime.gmt')}}</span>
                <q-select class="q-select timezone-time" :value="gmtHour" :options-array="gmtHourOptions" @change="ongmtHourChange"></q-select>
                <div class="hourspace">:</div>
                <q-select class="q-select timezone-time" :value="gmtMin" :options-array="gmtMinOptions" @change="ongmtMinChange"></q-select>
              </div>
              <div class="select-wrapper" v-if="timezonetype === 'country'">
                <q-select class="q-select timezone-country" :value="manualTimeconf.selectTimeZoneCountry" :options-array="timezonesCountry" @change="onCountryChange" :title="getTimezonesTitle()"></q-select>
              </div>
            </div>
          </div>
          <div class="table-row">
            <div class="title">{{$t('systemTime.setting')}}</div>
            <div class="time-setting value">
              <div class="formRow">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiomanual')" :checked="isItemChecked(1)" @click.native="onSelection(1)" :id="'radio-manual'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(1)}">
                  <div class="datetimetitle" style="display: inline-block; margin-right: 20px;">{{$t('systemTime.dateTime')}}</div>
                  <datetime-picker class="datetime-picker" :format="dateformat" v-model="manualTimeconf.manualDate" :value="manualTimeconf.manualDate" @change="onChange" :isDisabled="manualTimeconf.selectTimeSetting === 2" @click.native="onChange"></datetime-picker>
                  <div class="divide">/</div>
                  <div class="select-wrapper">
                    <q-select :isDisabled="manualTimeconf.selectTimeSetting === 2" :value="'' + manualTimeconf.manualHour" :options-array="hourOptions" @change="onHourChange" ></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualMins" :options-array="minOpitons" @change="onMinChange" :isDisabled="manualTimeconf.selectTimeSetting === 2"></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualSecs" :options-array="minOpitons" @change="onSecChange" :isDisabled="!isItemChecked(1)"></q-select>
                  </div>
                </div>
              </div>
              <div class="formRow sync-server">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiosync')" :checked="isItemChecked(2)" @click.native="onSelection(2)" v-validate :id="'radio-sync'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(2)}">
                  <div class="form-row dt">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('systemTime.server')}}</div>
                      <input class="dt-c" type="text" ref="server" name="server" v-model="manualTimeconf.serverUrl" v-validate.immediate="'server|required'" @keyup="onBlur" @blur="onBlur" :disabled="!isItemChecked(2)" :class="{'error': (errors.has('server') || serverInvaild) || resyncType === 'fail' }"/>
                      <span class="resync icon-refresh" @click="resync" v-if="resyncType !== 'loading'" :class="{disabled: !isItemChecked(2)}" style="transform: rotateY(180deg)"/>
                      <loading :mask=false :size="'small'" class="resync-load" v-else-if="resyncType === 'loading'"/>
                      <span class="status-icon" :class="syncStatus" v-if="resyncType === 'success' || resyncType === 'fail'"/>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="manualTimeconf.selectTimeSetting === 2 && (errors.has('server') || serverInvaild) || resyncType === 'fail'" class="errorMessage dt-c">{{syncErrorMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full" :title="$t('save')" @click="onSaveClick()" :disabled="isDisabled">{{$t('save')}}</button>
      </div>
    </div>
    <popup-confirm name="modal-alert" :dialog-header="$t('warning')" :dialog-message="dialogMsg" icon="w" :onlyOk=true ></popup-confirm>
  </div>
</template>

<script>
import moment from 'moment'
import Radio from './module/Radio'
import config from '../config'
import DatetimePicker from './module/DateTimePicker'
import qSelect from './module/Select.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'SystemTime',
  components: {
    Radio,
    config,
    DatetimePicker,
    qSelect
  },
  data () {
    return {
      modalname: 'modal-alert',
      sysCurTime: null,
      selectTimeSetting: 2,
      manualTimeconf: {
        selectTimeSetting: 2,
        selectTimeZone: '+00',
        selectTimeZoneCountry: 22,
        manualHour: 0,
        manualMins: 0,
        manualSecs: 0,
        manualDate: '',
        serverUrl: 'pool.ntp.org'
      },
      originalData: null,
      dateformat: 'YYYY/MM/DD',
      timeformat: 'HH:mm:ss',
      timezonetype: 'time',
      timezonesCountry: null,
      isShowLoading: false,
      isDisabled: true,
      hourOptions: [],
      minOpitons: [],
      secOptions: [],
      gmtHourOptions: [],
      gmtMinOptions: [],
      timezoneOptions: [
        {label: 'systemTime.bytime', value: 'time'},
        {label: 'systemTime.bycountry', value: 'country'}
      ],
      serverInvaild: false,
      haveDNS: false,
      startTime: null,
      syncTimeInterval: null,
      resyncType: '',
      isClickResync: false,
      curtimeIntervalId: null,
      curTimeUnixTime: null,
      displayTime: this.$t('systemTime.unknown')
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  beforeDestroy () {
    clearInterval(this.syncTimeInterval)
    this.syncTimeInterval = null
    clearInterval(this.curtimeIntervalId)
    this.curtimeIntervalId = null
  },
  beforeMount: function () {
    var number = '0'
    this.$store.commit('updateFullLoadingStatus', true)
    this.timezonesCountry = config.timezones
    for (let idx = 0; idx < 24; idx++) {
      this.hourOptions.push({
        label: '' + idx,
        value: '' + idx
      })
    }
    for (let idx = 0; idx < 60; idx++) {
      number = (idx < 10) ? '0' + idx : '' + idx
      this.minOpitons.push({
        label: '' + idx,
        value: '' + idx
      })
      this.secOptions.push({
        label: '' + idx,
        value: '' + idx
      })
      this.gmtMinOptions.push({
        label: number,
        value: number
      })
    }
    for (let type = 1; type < 3; type++) {
      if (type === 1) {
        for (let idx = 12; idx > -1; idx--) {
          if (idx > 0) { // 1: -; 2: +
            number = (idx < 10) ? '0' + idx : '' + idx
            this.gmtHourOptions.push({
              label: '-' + number,
              value: '-' + number
            })
          }
        }
      } else {
        for (let idx = 0; idx < 15; idx++) {
          number = (idx < 10) ? '0' + idx : '' + idx
          this.gmtHourOptions.push({
            label: '+' + number,
            value: '+' + number
          })
        }
      }
    }
  },
  created () {
    let me = this
    this.$validator.extend('server', {
      getMessage (field, val) {
        return me.$t('errorMessage.ntpserverError')
      },
      validate (value, field) {
        var temp = /^[\w\-_.]+$/
        if (value === '') {
          me.serverInvaild = true
        } else {
          me.serverInvaild = false
        }
        if (!temp.test(value)) {
          return false
        }
        return true
      }
    })
  },
  mounted: async function () {
    this.getData()
    this.getDNSConfig()
      .then((response) => {
        if (response.data.result && response.data.result.length > 0) {
          this.haveDNS = true
        } else {
          this.haveDNS = false
        }
      })
    this.getNtpAdminState()
    this.getSystemTime()
    this.getTimezone()
  },
  watch: {
    serverUrl: function (newValue, oldValue) {
      if (oldValue !== '') {
        this.onChange()
      }
    },
    isDisabled: function (value) {
      this.$store.commit('updateDataChanged', !value)
    },
    curTimeUnixTime: function (value) {
      if (value) {
        let time = moment.unix(value).utc()
        if (this.manualTimeconf.selectTimeSetting === 2) {
          time.utcOffset(this.manualTimeconf.selectTimeZone)
        }
        this.displayTime = time.format(this.dateformat + ' ' + this.timeformat)
      } else {
        this.displayTime = this.$t('systemTime.unknown')
      }
    },
    timeConfig: {
      handler (value) {
        if (value) {
          this.manualTimeconf.selectTimeSetting = (value.isNTP) ? 2 : 1
          this.manualTimeconf.selectTimeZone = value.timezone
          this.getCurrentTime()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getData: function () {
      let me = this
      this.isDisabled = true
      this.resyncType = ''
      this.getNtpAdminState()
      this.getSystemTime()
      this.getTimezone()
      this.getNtpConfig()
        .then((res) => {
          if (res.data.error_code === 200) {
            if (res.data.result === null || (res.data.result.length === 1 && res.data.result[0].key === '0')) {
            } else {
              me.manualTimeconf.serverUrl = res.data.result[0].val.Address
            }
          }
          me.$store.commit('updateFullLoadingStatus', false)
        }).catch((err) => {
          this.$log.error(err)
          me.$store.commit('updateFullLoadingStatus', false)
        })
    },
    getCurrentTime: function () {
      let currentTime = null
      let time = [this.timeConfig.time.YYYY, (this.timeConfig.time.MM - 1), this.timeConfig.time.DD, this.timeConfig.time.HR, this.timeConfig.time.MI, this.timeConfig.time.SE]
      this.timeConfig.isNTP ? currentTime = moment(time).utcOffset(this.timeConfig.timezone, true) : currentTime = moment(time).utcOffset(0, true)
      this.curTimeUnixTime = Number(currentTime.format('X'))
      this.manualTimeconf.manualDate = currentTime.format('YYYY/MM/DD')
      this.manualTimeconf.manualHour = this.timeConfig.time.HR
      this.manualTimeconf.manualMins = this.timeConfig.time.MI
      this.manualTimeconf.manualSecs = this.timeConfig.time.SE
      this.originalData = JSON.parse(JSON.stringify(this.manualTimeconf))
      this.setTimeInterval()
    },
    setTimeInterval: function () {
      if (this.curtimeIntervalId === null && this.curTimeUnixTime) {
        this.curtimeIntervalId = setInterval(() => {
          this.curTimeUnixTime += 1
        }, 1000)
      }
    },
    checkChangedItem: function () {
      let data = []
      let tempTimeZone = null
      if (this.timezonetype === 'country') {
        tempTimeZone = this.getCountryTimezone()
      } else {
        tempTimeZone = this.gmtHour + ':' + this.gmtMin
      }
      let temp = {
        date: this.manualDate,
        hour: this.manualHour,
        min: this.manualMins,
        sec: this.manualSecs,
        TimeSetting: this.selectTimeSetting,
        serverUrl: this.serverUrl,
        timezone: tempTimeZone
      }
      for (const key in temp) {
        if (temp.hasOwnProperty(key)) {
          const element = temp[key]
          if (element !== this.originalData[key]) {
            data.push(key)
          }
        }
      }
      return data
    },
    onChange: function () {
      if (this.manualTimeconf.selectTimeSetting !== this.originalData.selectTimeSetting) {
        let result = this.$compareObj(this.originalData, this.manualTimeconf)
        if (this.manualTimeconf.selectTimeSetting === 2) {
          (this.errors.count() > 0) ? result = true : result = false
        }
        this.isDisabled = result
      } else {
        let status = true
        for (const key in this.manualTimeconf) {
          const element = this.manualTimeconf[key]
          if (key !== 'selectTimeSetting') {
            if (this.manualTimeconf.selectTimeSetting === 1 && key !== 'serverUrl') {
              if (element !== this.originalData[key]) {
                status = false
              }
            } else {
              if (this.manualTimeconf.selectTimeSetting === 2 && (key === 'serverUrl' || key === 'selectTimeZone')) {
                if (element !== this.originalData[key]) {
                  status = false
                }
              }
            }
          }
        }
        this.isDisabled = status
      }
    },
    onTimetypeChange: function (value) {
      this.timezonetype = value
      this.isDisabled = false
    },
    ongmtHourChange: function (value) {
      this.manualTimeconf.selectTimeZone = value + ':' + this.gmtMin
      this.onChange()
    },
    ongmtMinChange: function (value) {
      this.manualTimeconf.selectTimeZone = this.gmtHour + ':' + value
      this.onChange()
    },
    onCountryChange: function (value) {
      this.manualTimeconf.selectTimeZoneCountry = value
      this.isDisabled = false
    },
    onHourChange: function (value) {
      this.manualTimeconf.manualHour = parseInt(value)
      this.onChange()
    },
    onMinChange: function (value) {
      this.manualTimeconf.manualMins = parseInt(value)
      this.onChange()
    },
    onSecChange: function (value) {
      this.manualTimeconf.manualSecs = parseInt(value)
      this.onChange()
    },
    resync: function () {
      this.$log.info('resync time server')
      this.resyncType = 'loading'
      this.isClickResync = true
      if (this.haveDNS) {
        this.setNtpServerStatus(false)
          .then((response) => {
            this.setNtpServerStatus(true)
              .then((res) => {
                this.startTime = new Date()
                this.checkSyncStatus(true)
              })
          })
      } else {
        this.resyncType = 'fail'
      }
    },
    checkSyncStatus: function (isResync) {
      let me = this
      me.syncTimeInterval = setInterval(() => {
        let currentTime = new Date()
        me.getNtpStatus().then((response) => {
          let status = response.data.result.ClientStatus
          if (status > 3 && status < 99) { // sync success
            me.$log.debug('sync success')
            if (isResync) {
              this.resyncType = 'success'
              me.getSystemTime()
            } else {
              me.getData()
            }
            clearInterval(me.syncTimeInterval)
          } else {
            // show error
            if ((currentTime - me.startTime) > 60000) {
              me.$log.debug('sync error')
              if (isResync) {
                this.resyncType = 'fail'
              } else {
                me.onOpen()
                me.getData()
                me.$store.commit('updateFullLoadingStatus', false)
              }
              clearInterval(me.syncTimeInterval)
            }
          }
        }).catch((err) => {
          me.$log.error(err)
        })
      }, this.intervalTime)
    },
    goSetTime: async function () {
      let temp = moment(this.manualTimeconf.manualDate)
      let timesetting = {
        YYYY: temp.year(),
        MM: temp.month() + 1, // .month() accepts numbers from 0 to 11
        DD: temp.date(),
        HR: this.manualTimeconf.manualHour,
        MI: this.manualTimeconf.manualMins,
        SE: this.manualTimeconf.manualSecs
      }
      let ntpStatus = {
        key: '1',
        val: { Address: this.manualTimeconf.serverUrl }
      }
      var tempArray = this.checkChangedItem()
      if (tempArray.includes('timezone')) {
        let tempTimeZone = ''
        if (this.timezonetype === 'country') {
          tempTimeZone = this.getCountryTimezone()
        } else {
          tempTimeZone = this.gmtHour + ':' + this.gmtMin
        }
        await this.setTimezone(tempTimeZone)
        /* if (this.manualTimeconf.selectTimeSetting === 2) {
          await this.setNtpServerStatus(false)
          this.setNtpServerStatus(true)
        } */
      }
      if (this.manualTimeconf.selectTimeSetting !== this.originalData.selectTimeSetting) {
        if (this.manualTimeconf.selectTimeSetting === 1) {
          this.setNtpServerStatus(false)
            .then((res) => {
              this.$log.debug(res)
              if (res.data.error_code === 200) {
                this.setSystemTime(timesetting)
                  .then((result) => {
                    if (result.data.error_code === 200) {
                      this.getData()
                    }
                  }).catch((err) => {
                    this.$log.error(err)
                    this.$store.commit('updateFullLoadingStatus', false)
                  })
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        } else {
          this.setNtpServerStatus(true)
            .then((res) => {
              if (this.originalData.serverUrl !== this.manualTimeconf.serverUrl) {
                this.setNtpConfig(ntpStatus)
                  .then((result) => {
                    if (result.data.error_code === 200) {
                      this.isDisabled = true
                      this.startTime = new Date()
                      this.checkSyncStatus()
                    }
                  }).catch((err) => {
                    this.$log.error(err)
                    this.$store.commit('updateFullLoadingStatus', false)
                  })
              } else {
                this.isDisabled = true
                this.startTime = new Date()
                this.checkSyncStatus()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        }
      } else {
        if (this.manualTimeconf.selectTimeSetting === 1) {
          this.setSystemTime(timesetting)
            .then((result) => {
              if (result.data.error_code === 200) {
                this.getData()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        } else {
          this.setNtpConfig(ntpStatus)
            .then((result) => {
              if (result.data.error_code === 200) {
                this.isDisabled = true
                this.startTime = new Date()
                this.checkSyncStatus()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        }
      }
    },
    onSaveClick: function () {
      this.$log.info('onSaveClick')
      if (this.manualTimeconf.selectTimeSetting === 2 && !this.haveDNS) {
        this.onOpen()
      } else {
        this.$store.commit('updateFullLoadingStatus', true)
        this.goSetTime()
      }
    },
    isItemChecked: function (item) {
      return (item === this.manualTimeconf.selectTimeSetting)
    },
    onSelection: function (item) {
      this.manualTimeconf.selectTimeSetting = item
      this.onChange()
    },
    getTimezonesTitle: function () {
      return this.timezonesCountry[this.manualTimeconf.selectTimeZoneCountry - 1].label
    },
    getCountryTimezone: function () {
      var result = ''
      var countryZone = config.timezones[this.manualTimeconf.selectTimeZoneCountry - 1].label
      result = countryZone.slice(countryZone.indexOf('T') + 1, countryZone.indexOf(')'))
      if (countryZone === '') {
        result = '+00:00'
      }
      return result
    },
    onBlur: function () {
      let me = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          me.isDisabled = true
        } else {
          me.onChange()
        }
      }).catch(() => {
        me.isDisabled = true
      })
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    ...mapActions([
      'getSystemTime', 'getNtpConfig', 'setNtpConfig', 'delNtpConfig', 'setSystemTime', 'getTimezone', 'setTimezone', 'getNtpStatus', 'getDNSConfig', 'setNtpServerStatus', 'getNtpAdminState'
    ]),
    ...mapMutations([ 'openModal', 'closeModal' ])
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      timeConfig: state => state.module.timeConfig,
      isDataChanged: state => state.app.isDataChanged,
      intervalTime: state => state.app.intervalTime,
      showFullLoading: state => state.module.showFullLoading
    }),
    gmtHour () {
      var value = '+00'
      var zone = JSON.parse(JSON.stringify(this.manualTimeconf.selectTimeZone))
      if (zone) {
        value = zone.split(':')[0]
      }
      return value
    },
    gmtMin () {
      var value = '00'
      var zone = JSON.parse(JSON.stringify(this.manualTimeconf.selectTimeZone))
      if (zone) {
        value = zone.split(':')[1]
      }
      return value
    },
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    dialogMsg () {
      let result = ''
      if (!this.haveDNS) {
        result = this.$t('errorMessage.dnserror')
      } else {
        result = this.$t('errorMessage.ntpsyncError')
      }
      return result
    },
    syncStatus () {
      let result = ''
      if (this.resyncType === 'success') {
        result = 'icon-tick'
      } else if (this.resyncType === 'fail') {
        result = 'icon-btn_close'
      }
      return result
    },
    syncErrorMsg () {
      let result = ''
      if (!this.haveDNS && this.isClickResync) {
        result = this.$t('errorMessage.dnserror')
      } else {
        if (this.resyncType !== 'fail') {
          if (this.serverInvaild) {
            result = this.$t('errorMessage.ipAndSubnetEmpty')
          } else {
            result = this.errors.first('server')
          }
        } else {
          result = this.$t('errorMessage.ntpsyncError')
        }
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped deep>

.content-tab.systime {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    div.content-body-header{
      padding-left: 20px !important;
    }
    .formRow.static {
      margin-top: 10px;
    }
    .formlabel {
      /deep/ .q-radio {
        >.text {
          font-size: 14px;
          color: #000000;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
      }
    }
    .forminput {
      >.table-row {
        display: flex;
        margin-top: 20px;
        &:first-child {
          margin-top: 0px;
        }
        &:nth-child(2) {
          margin-top: 18px;
        }
        .title {
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          font-weight: 500;
          width: 200px;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        .time-zone-title {
          line-height: 30px;
        }
        .display-date {
          color: #02208F;
          font-size: 14px;
          font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
        }
        input {
          border: 1px solid #979797;
          border-radius: 4px;
          width: 200px;
          line-height: 30px;
          height: 30px;
          display: inline-block;
          font-size: 13px;
          color: #000000;
        }
        .time-zone {
          .select-wrapper {
            display: inline-block;
            vertical-align: middle;
          }
          span {
            font-size: 14px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
          .hourspace {
            display: inline-block;
            margin: 0 5px;
            font-size: 14px;
            color: #000000;
            line-height: 30px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
        }
        .time-setting {
          >.formRow {
            margin-bottom: 20px;
            .formlabel {
              font-size: 13px;
              color: #000000;
              line-height: 18px;
              .q-radio {
                margin-right: 10px;
                > .icon {
                  width: 16px;
                  height: 16px;
                }
              }
            }
            .forminput {
              margin-top: 12px;
              margin-left: 30px;
              .title {
                font-size: 13px;
                color: #000000;
                line-height: 30px;
                display: inline-block;
              }
              >.value {
                display: inline-block;
              }
              input {
                border: 1px solid #979797;
                border-radius: 4px;
                font-size: 23px;
                height: 30px;
                color: #000000;
                line-height: 30px;
                width: 182px;
              }
              .select-wrapper {
                display: inline-block;
                vertical-align: middle;
                width: 60px;
                select {
                  padding-right: 32px;
                }
              }
              .datetimetitle {
                font-size: 14px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              .hourspace {
                display: inline-block;
                margin: 0 5px;
                font-size: 14px;
                color: #000000;
                line-height: 30px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              .divide {
                display: inline-block;
                font-size: 14px;
                color: #000000;
                line-height: 30px;
                margin: 0 10px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              &.disabled {
                color: #AEAEAE;
              }
            }
            &.sync-server {
              .forminput {
                margin-top: 12px;
                margin-left: 30px;
                display: block;
                .title {
                  font-size: 14px;
                  color: #000000;
                  line-height: 30px;
                  width: 100px;
                  font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
                }
                .form-row {
                  position: relative;
                }
                input {
                  border: 1px solid #979797;
                  border-radius: 4px;
                  font-size: 14px;
                  height: 30px;
                  color: #000000;
                  line-height: 30px;
                  width: 230px;
                  padding-right: 30px;
                  font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
                }
                &.disabled, &.disabled .title {
                  color: #AEAEAE;
                }
              }
            }
          }
        }
        .refresh {
          margin-left: 20px;
          vertical-align: middle;
          cursor: pointer;
          font-size: 20px;
          color: #000;
          &:hover {
            color: #89A5F4;
          }
          &:active {
            color: #2847A0;
          }
        }
        .resync {
          display: inline-block;
          cursor: pointer;
          margin-left: 10px;
          vertical-align: middle;
          font-size: 20px;
          color: #000;
          &:hover {
            color: #89A5F4;
          }
          &:active {
            color: #2847A0;
          }
          &.disabled {
            color: #AEAEAE;
            cursor: default;
            pointer-events: none;
          }
        }
        .resync-load {
          display: inline-block;
          margin-left: 10px;
          vertical-align: text-top;
          font-size: 16px;
          color: #000;
        }
        .icon-tick {
          font-size: 20px;
          color: #63B50A;
        }
        .icon-btn_close {
          font-size: 20px;
          color: #D0021B;
        }
        .status-icon {
          position: relative;
          vertical-align: middle;
          right: 60px;
        }
      }
      /deep/ .datetime-picker {
        display: inline-block;
        input {
          font-size: 14px;
          width: 180px;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
      }
      &.disabled{
        .q-select, .q-select .display-label {
          color: #AEAEAE;
          cursor: default;
          pointer-events: none;
        }
      }
    }
    .q-select {
      width: 60px;
      height: 30px;
      vertical-align: middle;
      /deep/ .display-label {
        font-size: 14px !important;
        line-height: 28px !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
      }
      &::after {
        background-color: #000;
        top: -25px;
      }
      &.timezone-country {
        width: 350px;
      }
      &.timezone-type {
        width: auto;
        min-width: 150px;
      }
    }
    >.content-body-footer {
      top: calc(100% - 40px);
      .q-button {
        min-width: 80px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    >.scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemTime.vue